import Icon from './Icon'
import Video from './Video'
import PropTypes from 'prop-types'
import React, { Component } from 'react'

export default class WorkspaceVideoClipHighlightStory extends Component {
  static propTypes = {
    isPlaying: PropTypes.bool.isRequired,
    onEnded: PropTypes.func.isRequired,
    onPlay: PropTypes.func.isRequired,
    workspaceVideoClip: PropTypes.object.isRequired
  }

  render() {
    const { isPlaying, onEnded, onPlay, workspaceVideoClip } = this.props
    const { image } = workspaceVideoClip
    const { src } = workspaceVideoClip.video

    return (
      <div className="insight-story-ng-controller">
        {!isPlaying && (
          <div
            className="image-container"
            style={{ backgroundImage: `url(${image.large})` }}
            onClick={onPlay}
          >
            <Icon name="play" />
          </div>
        )}
        {isPlaying && (
          <Video
            src={src}
            height="100%"
            listeners={{ ended: onEnded }}
            options={{ autoplay: true }}
            plugins={{
              clip: {
                startTime: workspaceVideoClip.startTime,
                endTime: workspaceVideoClip.endTime,
                restrictPlaybackToClip: true
              }
            }}
            controlBar={{ volumeControl: false }}
          />
        )}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ../src/components/WorkspaceVideoClipHighlightStory.js